// mutation
export function SET_LOGIN(state, result){
    state.loggedIn=result;
}